export default "__VITE_ASSET__LgBdPi01__"